import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface ILineGraphProps {
  data: any;
}

export const LineGraph = ({ data }: ILineGraphProps) => (
  <Line
    data={data}
    height={80}
    options={{
      plugins: {
        title: {
          display: true,
          text: 'Compulsion Tracker'
        },
        legend: {
          display: true,
          position: 'top'
        }
      },
      scales: {
        y: {
          min: 0,
          ticks: {
            precision: 0
          }
        }
      }
    }}
  />
);
